import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers, withProps } from 'recompose';
import { injectIntl } from 'react-intl';
import withPopover from 'shared/hocs/withPopover';
import { getActiveFiltersAmount } from 'modules/queues/Archive/selectors/appointmentsFilters';
import { resetAllAccordeonFilters } from 'modules/queues/Archive/actions/archiveAppointmentsFilters';

import FiltersAccordeonGroup from './FiltersAccordeonGroup';


export default compose(
  withPopover(false),
  injectIntl,
  connect(
    state => ({ activeFilters: Array(getActiveFiltersAmount(state)) }),
    { resetAllAccordeonFilters },
  ),

  withProps(({ intl }) => ({
    iconTooltipMessage: intl.formatMessage({
      id: 'Appointments.AppointmentsList.Filter.FilterButton.Title',
      defaultMessage: '** Filter appointments',
    }),
  })),

  withHandlers({
    escapeHandler: ({ closePopover, anchorEl }) => e => {
      if (!!anchorEl && (e.key === 'Escape' || e.keyCode === 27)) closePopover();
    },
  }),

  lifecycle({
    componentDidMount() {
      document.addEventListener('keydown', this.props.escapeHandler);
    },

    comonentWillUnmount() {
      document.removeEventListener('keydown', this.props.escapeHandler);
    },
  }),
)(FiltersAccordeonGroup);
